import { Button, Form, Mentions, Select, Switch } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { getFiles } from '../../../../services/assistant'
import { InputSearch } from '../../../input-search'
import { EnterOutlined, UploadOutlined } from "@ant-design/icons";
import PublicFile from "../../../public-file";

const modes = [
  {
    label: "Arquivos do conhecimento/prompt",
    value: "AI_FILES"
  },
  {
    label: "Arquivos fixas",
    value: "FILES"
  }
]

export default function SendFile({ fieldName, parameters, form }) {
  const mode = Form.useWatch(['actions', fieldName, 'action', 'data', 'mode'], form)

  const availableArrayString = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .filter(({ type, items }) => type === 'array' && items?.type === 'string')
      .map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item name={[fieldName, 'action', 'data', 'mode']}
        initialValue={'FILES'}
        label={'Modo dos arquivos'}>
        <Select options={modes} placement={"Selecione o modo de arquivos"} />
      </Form.Item>
      {mode === 'FILES' && (
        <Form.Item
          label="Arquivos fixas"
          name={[fieldName, 'action', 'data', 'files']}
          rules={[{
            required: true,
            message: "É obrigatório adicionar pelo menos um arquivo.",
          }]}
        >
          <PublicFile multiple image>
            <Button icon={<UploadOutlined />}>Subir Arquivo</Button>
          </PublicFile>
        </Form.Item>
      )}
      {mode === 'AI_FILES' && <Form.Item
        label={'Arquivos do prompt ou conhecimento'}
        name={[fieldName, 'action', 'data', 'aiFiles']}
        help={'Selecione um parametro do gatilho que seja uma lista de textos'}
      >
        <Select placeholder={'Selecione um parametro do gatilho'} options={availableArrayString} />
      </Form.Item>}
    </>
  )
}
